cockpitApp.controller('detailLocationController', [
  '$scope', 'locationHelper',
  function($scope, locationHelper)
  {
    $scope.locationHelper = locationHelper;
  }
]);
